import React from "react";
import LegalLayout from "../../components/LegalLayout";
import { hotel } from "../../mock";

const Kvkk = () => (
  <LegalLayout title="KVKK Aydınlatma Metni" updated="Haziran 2026">
    <p>
      İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK")
      kapsamında, kişisel verilerinizin veri sorumlusu sıfatıyla Safranbolu Çelebi
      Otel tarafından nasıl işlendiği konusunda sizi bilgilendirmek amacıyla
      hazırlanmıştır.
    </p>

    <h2>1. Veri Sorumlusu</h2>
    <p>
      <strong>Safranbolu Çelebi Otel</strong>
      <br />
      {hotel.address}
      <br />
      Tel: {hotel.phones[0]} · E-posta: {hotel.email}
    </p>

    <h2>2. İşlenen Kişisel Veriler</h2>
    <ul>
      <li>Kimlik ve iletişim bilgileri (ad, soyad, telefon, e-posta)</li>
      <li>Rezervasyon ve konaklama talep bilgileri</li>
      <li>İletişim formu ve talepleriniz aracılığıyla ilettiğiniz veriler</li>
    </ul>

    <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
    <ul>
      <li>Rezervasyon ve konaklama süreçlerinin yürütülmesi</li>
      <li>Talep ve şikâyetlerin değerlendirilmesi ve yanıtlanması</li>
      <li>Hizmet kalitesinin artırılması ve müşteri memnuniyetinin sağlanması</li>
      <li>Yasal yükümlülüklerin yerine getirilmesi</li>
    </ul>

    <h2>4. Hukuki Sebepler</h2>
    <p>
      Kişisel verileriniz; bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili
      olması, hukuki yükümlülüğün yerine getirilmesi, meşru menfaat ve açık rızanızın
      bulunması hukuki sebeplerine dayanılarak işlenmektedir.
    </p>

    <h2>5. Kişisel Verilerin Aktarımı</h2>
    <p>
      Kişisel verileriniz, yalnızca yukarıda belirtilen amaçlarla sınırlı olmak
      üzere ve yasal düzenlemelerin öngördüğü çerçevede yetkili kamu kurum ve
      kuruluşlarına aktarılabilir. Verileriniz ticari amaçla üçüncü kişilere
      satılmaz.
    </p>

    <h2>6. Saklama Süresi</h2>
    <p>
      Kişisel verileriniz, işlenme amacının gerektirdiği süre boyunca ve ilgili
      mevzuatta öngörülen süreler saklandıktan sonra silinir, yok edilir veya anonim
      hâle getirilir.
    </p>

    <h2>7. İlgili Kişinin Hakları (KVKK md. 11)</h2>
    <p>KVKK kapsamında sahip olduğunuz haklar şunlardır:</p>
    <ul>
      <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
      <li>İşlenmişse buna ilişkin bilgi talep etme</li>
      <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
      <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
      <li>Kanunda öngörülen şartlarda silinmesini veya yok edilmesini isteme</li>
      <li>Aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
      <li>Zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
    </ul>

    <h2>8. Başvuru ve İletişim</h2>
    <p>
      Yukarıdaki haklarınıza ilişkin taleplerinizi <strong>{hotel.email}</strong>{" "}
      adresine e-posta göndererek veya {hotel.address} adresine yazılı olarak
      iletebilirsiniz. Talepleriniz en kısa sürede ve en geç 30 gün içinde
      sonuçlandırılır.
    </p>
  </LegalLayout>
);

export default Kvkk;
